import React from 'react';
interface LedFrameProps {
  children: React.ReactNode;
  className?: string;
  radius?: number;
  runner?: boolean;
  delay?: number;
}

/** Marco con borde LED neón que late y, opcionalmente, una luz que recorre el contorno. */
export function LedFrame({
  children,
  className = '',
  radius = 16,
  runner = true,
  delay = 0
}: LedFrameProps) {
  return <div className={`led-frame relative ${className}`} style={{
    borderRadius: radius,
    animationDelay: `${delay}s`
  }} data-id="element-1066" data-mp="2oppo3825hwmk">
      {children}
      {runner && <svg aria-hidden className="pointer-events-none absolute inset-0 h-full w-full overflow-visible" data-id="element-1067" data-mp="1wxgucbxq3ido">
          <rect x="0" y="0" width="100%" height="100%" rx={radius} ry={radius} pathLength={100} className="led-runner" style={{
        animationDelay: `${-delay * 1.5}s`
      }} data-id="element-1068" data-mp="20wzirhor6bl9" />
        </svg>}
    </div>;
}